<template>
  <div class="ms-3 auth-btns-container" v-if="!$store.state.isAuthenticated">
    <router-link
      class="register-btn auth-btn desktop-only"
      :to="{ name: 'register' }"
    >
      <CdAccount class="ms-2" />
      أنشئ حسابك
    </router-link>
    <router-link
      class="login-btn auth-btn desktop-only"
      :to="{ name: 'login' }"
    >
      <BxLogInCircle class="ms-2" />
      تسجيل الدخول
    </router-link>
    <router-link class="login-btn auth-btn mobile-only" :to="{ name: 'login' }">
      <BxLogInCircle class="ms-2" />
      تسجيل
    </router-link>
  </div>
  <div class="ms-3 auth-btns-container" v-else>
    <button @click="logout" class="logout-btn auth-btn desktop-only">
      <MiLogoutHalfCircle class="ms-2" />
      تسجيل خروج
    </button>
    <button @click="logout" class="logout-btn auth-btn text-center mobile-only">
      <MiLogoutHalfCircle />
      خروج
    </button>
  </div>
</template>
<script>
import {
  MiLogoutHalfCircle,
  BxLogInCircle,
  CdAccount,
} from "@kalimahapps/vue-icons";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

export default {
  name: "AuthBtnsComponent",
  components: {
    MiLogoutHalfCircle,
    BxLogInCircle,
    CdAccount,
  },
  methods: {
    logout() {
      Swal.fire({
        title: " متاكد من تسجيل الخروج من المنصه ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#57F2AA",
        cancelButtonColor: "#e74c3c",
        confirmButtonText: "تسجيل خروج",
        cancelButtonText: " الغاء ",
      }).then((result) => {
        if (result.isConfirmed) {
          Cookies.remove("user_data");
          Cookies.remove("user_token");
          this.$store.commit("LOGOUT_USER");
          this.$router.push("/login");
          Swal.fire({
            toast: true,
            title: " تم تسجيل الخروج بنجاح ",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            position: "top-end",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.auth-btn {
  all: unset;
  padding: 0.5rem 1rem;
  border-radius: 9.53px;
  border: 1.36px solid #1e1e1e;
  font-weight: bold;
  cursor: pointer;
}
.login-btn,
.logout-btn {
  background-color: #dad2c5;
  color: #1e1e1e;
}

.register-btn {
  background-color: #2b4239;
  color: #fff;
  margin-left: 1rem;
}
.mobile-only {
  display: none;
}
@media (max-width: 767px) {
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: flex !important;
    align-items: center;
    padding: 0.5rem;
  }
}
</style>
